<template>
    <FormSelectTree
        :key="spaceId"
        ref="FormTreeSelect"
        :load-options="fetchCategories"
        :normalizer="normalizer"
        :placeholder="$t('category')"
        :selected-options-label="$t('selectedCategories')"
        :multiple="multiple"
        :show-count-value="showCountValue"
        value-consists-of="ALL"
        v-bind="$attrs"
        @loading="loading => $emit('loading', loading)"
        v-on="$listeners"
    />
</template>



<script>
    import FormSelectTree from './FormSelectTree.vue';

    export default {
        name: 'FormCategoryTreeSelect',
        components: {
            FormSelectTree,
        },
        props: {
            showCountValue: {
                type: Boolean,
                default: true,
            },
            multiple: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                requestProducerProductCategories: this.$req('space/ProducerProductCategories'),
            };
        },
        computed: {
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
        },
        methods: {
            fetchCategories() {
                this.$emit('loading', true);
                return this.fetchProducerProductCategories()
                    .then(this.buildTree)
                    .finally(() => {
                        setTimeout(() => this.$emit('loading', false), 200);
                    });
            },
            fetchProducerProductCategories() {
                return this.requestProducerProductCategories.get(this.spaceId);
            },
            buildTree(itemsOriginal) {
                const items = structuredClone(itemsOriginal);
                // 1. Zbuduj mapę id → węzeł z children = []
                const map = {};
                items.forEach(item => {
                    map[item.id] = {
                        ...item,
                        children: [],
                    };
                });
                // 2. Przypisz węzły do odpowiedniego parent.children
                items.forEach(item => {
                    if (item.parent && item.parent.id != null) {
                        const pid = item.parent.id;
                        if (map[pid]) {
                            map[pid].children.push(map[item.id]);
                        }
                    }
                });
                // 3. Usuń puste tablice children
                Object.values(map).forEach(node => {
                    if (node.children.length === 0) {
                        delete node.children; // eslint-disable-line no-param-reassign
                    }
                });
                // 4. Zwróć tylko korzenie (lvl === 0)
                return items.filter(item => item.lvl === 0).map(root => map[root.id]);
            },
            normalizer(node) {
                return {
                    id: node.id,
                    label: node.name,
                };
            },
        },
    };
</script>
